import React from 'react';
import { FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import currencies from '../../../assets/i18n/currencies.json';

const numberFormatOptions = { style: 'currency', currencyDisplay: 'symbol', maximumFractionDigits: 4 };

/**
 * Label para valores monetários
 * @param {number} props.value valor do label 
 * @param {string} props.locale valor do locale 
 * @author Fábio Sartori
 * @copyright 06/2019
 */
const CurrencyLabel = ( props ) => (
    <FormattedNumber
        value={props.amount}
        currency={currencies[props.locale]}
        {...numberFormatOptions}
    />
);
export default CurrencyLabel;

CurrencyLabel.propTypes = {
    amount: PropTypes.number.isRequired,
    locale: PropTypes.string.isRequired
}